@import 'fluid-modal.theme.less';

@import '../../styles/mixins/fluid-overlay.mixin.less';
@import '../../styles/mixins/fluid-transitions.mixin.less';
@import '../../styles/mixins/fluid-fading-animations.mixin.less';
@import '../../styles/mixins/fluid-common-components.mixin.less';

// ================================================================ //
// -- Theme Definition

:host {
  display: block;

  *, ::after, ::before {
    box-sizing: border-box;
  }

  .fluid-modal {

    /**
     * LEGACY THEME
     */
    &.legacy {
      @import '../../styles/variables-iuw-legacy.less';
      @modal-tokens: @modal-tokens-legacy;
      @modal();
    }

    /**
     * LIBERTY MUTUAL THEME
     */
    &.lm {
      @import '../../styles/variables-lm.less';
      @modal-tokens: @modal-tokens-lm;
      @modal();
    }

    /**
     * LM CORPORATE THEME
     */
    &.corp, &.default {
      @import '../../styles/variables-lm-corp.less';
      @modal-tokens: @modal-tokens-corp;
      @modal();
    }

    /**
     * PORTAL THEME
     */
    &.portal {
      @import '../../styles/variables-lm-portal.less';
      @modal-tokens: @modal-tokens-portal;
      @modal();
    }
  }

  &(:not(.hydrated)) {
    display: none;
  }
}


// ================================================================ //
// -- Component Detached Ruleset

@modal: {
  @header: @modal-tokens[@header];
  @content: @modal-tokens[@content];
  @footer: @modal-tokens[@footer];

  position: fixed;
  top: 0; bottom: 0; left: 0; right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: @font-family;
  font-size: @modal-tokens[font-size];
  font-weight: @modal-tokens[font-weight];
  line-height: @modal-tokens[line-height];
  color: @modal-tokens[text-color];
  overflow-y: auto;
  overscroll-behavior: contain;
  will-change: opacity;

  @media @screen-ie-only {
    justify-content: flex-start;
    align-items: flex-start;
  }

  // ==== Visible & Hidden

  &.modal-visible {
    .fade-in(@duration: @transition-durations[medium]);
  }

  &.modal-hidden {
    .fade-out(@duration: @transition-durations[medium]);
    overflow: hidden;
  }

  &.disable-interaction {
    display: none;
  }

  // ==== Background Overlay

  .page-overlay {
    .full-screen-overlay();
    z-index: -1;

    &.overlay-transparent {
      background-color: transparent;
    }
  }

  // ==== Focus Trap Container

  fluid-focus-trap {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;

    &.size-full {
      width: 100%;
      height: 100%;
      margin: 0;
    }
  }

  // ==== Modal Container

  .modal-container {
    min-width: 350px;
    max-width: 1728px;
    position: relative;
    margin-top: 2em;
    margin-bottom: 2em;
    background: @white;
    border-radius: @modal-tokens[border-radius];
    padding-top: @modal-tokens[padding-top];
    padding-bottom: @modal-tokens[padding-bottom];
    padding-left: @modal-tokens[padding-left];
    padding-right: @modal-tokens[padding-right];
    box-shadow: @modal-tokens[box-shadow];
    outline: none; // Removes :focus "ring" caused by Focus Trap setting tabIndex to -1

    // == Limit Overflow (Container)

    &.limit-overflow {
      margin: 0;
    }

    // == Sizes

    .create-modal-sizes();

    &.modal-full {
      min-width: unset;
      max-width: unset;
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 0; bottom: 0; left: 0; right: 0;
      margin: 0;
      padding-top: @modal-tokens[padding-top] * 1.5;
      padding-bottom: @modal-tokens[padding-bottom] * 1.5;
      padding-left: @modal-tokens[padding-left] * 2;
      padding-right: @modal-tokens[padding-right] * 2;
      border-radius: 0;

      .fluid-modal-content {
        flex: 1 1 auto;
        max-height: unset;
        overflow-y: auto;
      }
    }
  }

  // ==== Header

  .fluid-modal-header {
    border-bottom: @modal-tokens[section-seperator];
    padding-bottom: @header[padding-bottom];
    position: relative;
    font-family: inherit;

    &.header-empty {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  // ==== Title

  .fluid-modal-title {
    font-size: 1.5em;
    font-weight: @header[font-weight];
    margin: 0;
  }

  // ==== Dismiss Button

  .fluid-modal-dismiss {
    position: absolute;
    top: -1em;
    right: -1em;
    z-index: 1;

    .close-button();
  }

  // ==== Slot Wrapper

  .fluid-modal-content {
    display: block;
    position: relative;
    padding-top: @content[padding-top];
    padding-bottom: @content[padding-bottom];

    &.limit-overflow {
      max-height: 70vh;
      overflow-y: auto;
      overscroll-behavior: contain;
    }
  }

  // ==== Footer

  .fluid-modal-footer {
    border-top: @modal-tokens[section-seperator];
    padding-top: @footer[padding-top];
    text-align: right;
    display: block;

    &.footer-empty {
      border-top: none;
      padding: 0;
    }
  }
}


// ================================================================ //
// -- Mixins

.create-modal-sizes() {
  @size-values: {
    xxs: 20;
    xs: 20;
    sm: 30;
    md: 60;
    lg: 80;
    xl: 90;
  }

  each(@size-values, {
    &.modal-@{key} {
      width: ~'@{value}vw';
    }
  });
}
